import http from 'src/app/http';


const getCountries = () => http.get('/dictionaries?names=countries');


export default {
  getCountries
};
